export type VuexUserActionNameList =
  | "ALIASES_REQUEST"
  | "COURSE_HISTORY_REQUEST"
  | "GROUPS_REQUEST"
  | "LOAD_LOCAL_STORAGE_DATA_REQUEST"
  | "LOAD_USER_PROFILE"
  | "LOGIN_REQUEST"
  | "LOGIN_SSO"
  | "PASSWORD_RESET"
  | "SELECT_ALIAS"
  | "SET_PASSWORD_WITH_TMP_PASSWORD_REQUEST"
  | "SET_PASSWORD_WITH_TOKEN_REQUEST"
  | "UPDATE_USER_PROFILE"
  | "VALIDATE_TMP_PASSWORD_REQUEST"
  | "VALIDATE_JWT_REQUEST"
  | "VALIDATE_RESET_PASSWORD_JWT_REQUEST";
export type VuexUserActionNames = {
  [T in VuexUserActionNameList]: string;
};

export type VuexUserMutationNameList =
  | "ALIASES"
  | "COURSE_HISTORY"
  | "GROUPS"
  | "LOCAL_STORAGE_DATA"
  | "LOGIN_FAILURE"
  | "LOGIN_SUCCESS"
  | "LOGOUT"
  | "SELECTED_ALIAS"
  | "SET_PASSWORD_WITH_TMP_PASSWORD"
  | "SET_PASSWORD_RESET_ERROR"
  | "SET_USER_PROFILE"
  | "VALIDATE_TMP_PASSWORD"
  | "VALIDATE_JWT_FAILURE"
  | "VALIDATE_RESET_PASSWORD_JWT_FAILURE"
  | "VALIDATED_JWT";
export type VuexUserMutationNames = {
  [T in VuexUserMutationNameList]: string;
};

export const VUEX_USER_NAMESPACE = "user";

export const VUEX_USER_ACTION_NAMES: VuexUserActionNames = {
  ALIASES_REQUEST: "alias_fetch_request",
  COURSE_HISTORY_REQUEST: "course_history_request",
  GROUPS_REQUEST: "groups_request",
  LOAD_LOCAL_STORAGE_DATA_REQUEST: "load_local_storage_request",
  LOAD_USER_PROFILE: "load_user_profile",
  LOGIN_REQUEST: "login_request",
  LOGIN_SSO: "login_with_sso",
  PASSWORD_RESET: "password_reset",
  SELECT_ALIAS: "select_alias",
  SET_PASSWORD_WITH_TMP_PASSWORD_REQUEST: "set_password_request",
  SET_PASSWORD_WITH_TOKEN_REQUEST: "set_password_with_token_request",
  UPDATE_USER_PROFILE: "update_user_profile",
  VALIDATE_TMP_PASSWORD_REQUEST: "validate_tmp_password_request",
  VALIDATE_JWT_REQUEST: "validate_jwt_request",
  VALIDATE_RESET_PASSWORD_JWT_REQUEST: "validate_reset_password_jwt"
};

export const VUEX_USER_MUTATION_NAMES: VuexUserMutationNames = {
  ALIASES: "aliases",
  COURSE_HISTORY: "course_history",
  GROUPS: "groups",
  LOCAL_STORAGE_DATA: "local_storage_data",
  LOGIN_FAILURE: "login_failure",
  LOGIN_SUCCESS: "login_success",
  LOGOUT: "logout",
  SELECTED_ALIAS: "selected_alias",
  SET_PASSWORD_WITH_TMP_PASSWORD: "set_password_with_tmp_password",
  SET_PASSWORD_RESET_ERROR: "set_password_reset_error",
  SET_USER_PROFILE: "set_user_profile",
  VALIDATE_TMP_PASSWORD: "validate_tmp_password",
  VALIDATE_JWT_FAILURE: "validate_jwt_failure",
  VALIDATE_RESET_PASSWORD_JWT_FAILURE: "validate_reset_password_jwt_failure",
  VALIDATED_JWT: "validate_jwt_response"
};
